import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-details'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import AccountAdmin from '/components/account/account'

const AccountManagementDetails = () => {

  const navigate = useNavigate()

  const { client,user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  if (user?.permissions.client_admin) return (
    <PageWrapper title="Account Management" HelpText={HelpText} heading="Company Details" menu={<Menu client={client} user={user}/>}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <AccountAdmin />
      </div>
    </PageWrapper>
  )}

export default AccountManagementDetails

/*

  ****** Ensure we check permissions in API before committing changes!


  Add later... double check that this is taken from client DB when duplicating templates!

      <li>Google issuer ID / Google email / key</li>
      <li>Apple pass type ID</li>
      <li>apple team id</li>
      <li>apple signer certificate / key / passphrase</li>
*/